import React from 'react';
import { connect } from 'react-redux';
import KeyField from '../KeyField';

const component = ({ text, constants }) => (
  <div>
    <KeyField text={text} constants={constants} number="" />
    <KeyField text={text} constants={constants} number="0" />
    <KeyField text={text} constants={constants} number="00" />
    <KeyField text={text} constants={constants} number="000" />
    <KeyField text={text} constants={constants} number="0000" />
    <KeyField text={text} constants={constants} number="00000" />
    <KeyField text={text} constants={constants} number="000000" />
    <KeyField text={text} constants={constants} number="0000000" />
    <KeyField text={text} constants={constants} number="00000000" />
    <KeyField text={text} constants={constants} number="000000000" />
    <KeyField text={text} constants={constants} number="0000000000" />
  </div>
);

const mapStateToProps = state => ({
  text: state.text,
  constants: state.constants
});

const mapDispatchToProps = () => ({});

const HomePage = connect(mapStateToProps, mapDispatchToProps)(component);

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/KeyFieldPage/index.js